export default __webpack_public_path__ + "static/media/le_lionmini.ffa7b19d.jpg";